export const isRememberChange = (payload) => {
  return {
    type: 'REMEMBER',
    payload
  };
};

export const loginDetails = (payload) => {
  return {
    type: 'LOGIN',
    payload
  };
};

export const getSchemeID = (payload) => {
  return {
    type: 'SCHEMEID',
    payload
  };
};

export const getScheme_Id = (payload) => {
  return {
    type: 'SCHEME_ID',
    payload
  };
};

export const setPermittedSections = (payload) => {
  return {
    type: 'PERMITTED_SECTION',
    payload
  };
};

export const getName = (payload) => {
  return {
    type: 'NAME',
    payload
  };
};

export const modifyUserName = (payload) => {
  return {
    type: 'MODIFIY_USER_NAME',
    payload
  };
};


export const updateProfile = (payload) => {
  return {
    type: 'UPDATE_PROFILE',
    payload
  };
};
export const storeScroll = (payload) => {
  return {
    type: "STORESIDEBAR",
    payload,
  }
}
export const setRole = (payload) => {
  return {
    type: 'SET_ROLE',
    payload
  };
};